import React, { useContext } from 'react';
import Header from '../../containers/HeaderNew.container';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import CheckInQR from './CheckInQR';
import MobileContext from 'context/MobileContext';
import { useSelector } from 'react-redux';

const HeaderFooterLayout = ({ children }) => {
  const isMobile = useContext(MobileContext);
  const hasClosedPopup = localStorage.getItem('tncPopupClosed') === 'true';
  const isDocumentPopUp = useSelector(
    state => state?.termsAndConditions?.termsAgreementDetails?.isDocumentPopUp
  );
  const isLiabilityWaiverApproved = useSelector(
    state => state?.termsAndConditions?.termsAgreementDetails?.liabilityWaiver
  );
  const isCancelMembershipPath = window.location.pathname === '/membership-form/cancel';

  return (
    <div className={styles.templateWrapper}>
      <Header />
      <div className={styles.mainWrapper}>
        <div className={styles.content}>{children}</div>
        {((isMobile && !isDocumentPopUp) ||
        (isMobile && isDocumentPopUp && isLiabilityWaiverApproved) ||
        (isMobile && hasClosedPopup)) && !isCancelMembershipPath ? (
          <CheckInQR />
        ) : null}
      </div>
    </div>
  );
};

HeaderFooterLayout.propTypes = {
  children: PropTypes.element.isRequired,
  profile: PropTypes.string,
};

HeaderFooterLayout.defaultProps = {
  profile: '',
};

export default HeaderFooterLayout;
